// Punkt model for the erhverv Vilkår step. Mirrors what syncs to contract_clauses.
export type ErhvervPunkt =
  | { kind: 'builtin'; key: string; title: string; baseText: string; overrideText?: string }
  | { kind: 'custom'; localId: string; text: string }

// INVARIANT: no builtin library clause may ever be titled 'Eget vilkår' — the
// draft-resume path matches stored clauses back to builtins by exact title, so
// a builtin with this title would falsely capture custom punkter on resume.
export const punktTitle = (p: ErhvervPunkt): string =>
  p.kind === 'builtin' ? p.title : 'Eget vilkår'

export const punktText = (p: ErhvervPunkt): string =>
  p.kind === 'builtin' ? (p.overrideText ?? p.baseText) : p.text

// Inputs the wizard already owns. `included` = the Generering include-map
// (section-key → not excluded); callers must pass a function that returns true
// for keys absent from the exclude-set.
export interface VilkaarSectionInputs {
  included: (key: string) => boolean
  hasBidragRows: boolean        // leje lines with kategori === 'bidrag'
  forbrugOn: boolean            // any afregning type set OR internet/tv bidrag
  indflytningsopkraevning: boolean
  hasEngangsbeloeb: boolean
  hasBankgaranti: boolean
  hasDriftSkatter: boolean
  reguleringOn: boolean         // regulering type !== 'ingen'
}

// Mirror of erhverv_pdf.py's sec() order. The PDF is the source of truth —
// the live preview is the cross-check. Order (from erhverv_pdf.py):
// §1 Parterne (always) · §2 Det lejede (always) · Anvendelse [included('anvendelse')]
// · Lejeperiode [included('lejeperiode')] · Leje (always)
// · Faste bidrag [hasBidragRows && included('faste_bidrag')]
// · Forbrug [forbrugOn && included('forbrug')] · Depositum [included('depositum')]
// · Indflytningsopkrævning [flag && included('indflytningsopkraevning')]
// · Engangsbeløb [flag && included('engangsbeloeb')] · Bankgaranti [flag && included('bankgaranti')]
// · Drift og skatter [flag && included('drift_skatter')] · Regulering [on && included('regulering')]
// · → Vilkår
export function vilkaarSectionNo(s: VilkaarSectionInputs): number {
  let n = 2
  if (s.included('anvendelse')) n++
  if (s.included('lejeperiode')) n++
  n++ // Leje — always
  if (s.hasBidragRows && s.included('faste_bidrag')) n++
  if (s.forbrugOn && s.included('forbrug')) n++
  if (s.included('depositum')) n++
  if (s.indflytningsopkraevning && s.included('indflytningsopkraevning')) n++
  if (s.hasEngangsbeloeb && s.included('engangsbeloeb')) n++
  if (s.hasBankgaranti && s.included('bankgaranti')) n++
  if (s.hasDriftSkatter && s.included('drift_skatter')) n++
  if (s.reguleringOn && s.included('regulering')) n++
  return n + 1
}
